import React from 'react'
import styled from 'styled-components'
import { imgUrl } from 'features/constants'
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setSingleCampaignData } from 'features/givingCampaigns/givingCampaignSlice';
import useImageLoader from 'hooks/useImageLoader';
import { IoIosArrowBack, IoIosArrowForward  } from "react-icons/io";
import { useTranslation } from 'react-i18next'
import { useLocalizedFormatters } from 'i18n/useLocalizedFormatters'

export default function CampaignItem({ campaign }) {
    const { t } = useTranslation('giving')
    const { formatCurrency } = useLocalizedFormatters()

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const handleNavigate = () => { 
        dispatch(setSingleCampaignData(campaign))
        navigate(`/campaigns/${campaign._id}`)
    }
    const [view, setView] = React.useState('details')
    const [imageSource, { blur }] = useImageLoader(`${campaign.images[0].urlSmall}`, `${campaign.images[0].url}`)

    return (
        <CIC onClick={handleNavigate}> 
            <CICL>

                <img
                    src={imageSource} 
                    style={{
                        filter: blur ? 'blur(2px)' : 'none',
                        transition: blur ? 'none' : 'filter 0.3s ease-out',
                    }}
                    alt="campaign" 
                    />
            </CICL>
            <CICR>
                <span style={{  marginTop: '5px' }}>{campaign.title}</span>  

                {
                    campaign.totalDonations !== 0 &&
                    <TotalsContainer>
                        <StatusContainer>
                            <RaisedColor
                                progress={
                                    `${Number(campaign.totalDonations/campaign.goal).toFixed(2) * 100}%`
                                }    
                                >
                            </RaisedColor>
                        </StatusContainer>
                        <Totals>
                            <p>{t('campaigns.totalDonations')}</p>
                            <p>{formatCurrency(campaign.totalDonations)}</p>
                        </Totals>
                    </TotalsContainer>
                } 
            </CICR> 
        </CIC>
    )
}

const RaisedColor = styled.div`
    width: ${props => props.progress};
    height: 10px;
    background-color: #21ad46;
    border-radius: 10px;
`

const CIC = styled.div`
    width: 49%;
    height: 300px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;
    padding: 12px;
    border-radius: 8px;
    background-color: white;
    border: 1px solid #edf0f2;
    box-shadow: 0 4px 16px rgba(61, 70, 78, 0.10);
    cursor: pointer;
    transition: box-shadow 0.25s ease, transform 0.25s ease, border-color 0.25s ease;

    &:hover{
        border-color: #e0e7eb;
        box-shadow: 0 10px 24px rgba(61, 70, 78, 0.14);
        transform: translateY(-1px);
    }

    @media (max-width: 768px){
        width: 400px;
        height: 400px;
    }

`
const CICL = styled.div`
    width: 100%;
    height: 80%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 8px;
    }
`

const ImageArrow = styled.div`
    width: 30px;
    height: 30px;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    visibility: hidden  ;
`

const CICR = styled.div`
    width: 100%;
    height: 20%;
    color: var(--lightThemeFontColor);
    font-size: 16px;
    font-weight: 700;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
`
const TotalsContainer = styled.div`
    width: 100%; 
    margin-top: 3px;
`
const StatusContainer = styled.div`
    width: 100%;
    display: flex;
    height: 10px;
    align-items: flex-start;
    justify-content: flex-start;
    background-color: #f2f6f8;
    border-radius: 10px;
`
const Totals = styled.div`
    width: 100%;
    display: flex;
    margin-top: 3px;
    justify-content: space-between;
    font-size: 13px;
    color: #7b7f82;
    font-weight: 500;
    
`
